import * as S from './TrustpilotRating.styles'
import { useTranslation } from 'react-i18next'

export default function TrustpilotRating() {
  const { t } = useTranslation()

  return (
    <S.ReviewContainer>
      <S.ReviewStarsSvg />
      <S.ReviewScore> 4.7/5 </S.ReviewScore>
      <S.VSeparator />
      <S.TextWrapper>
        <S.TrustPilotLogo />, 30K+ {t('homepage.covered.reviews')}
      </S.TextWrapper>
    </S.ReviewContainer>
  )
}
